import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import AppExperience from '../../features/apps/components/AppExperience';

const AppExperienceRoute = () => {
  return (
    <ProtectedRoute requiresAuth={true}>
      <AppExperience />
    </ProtectedRoute>
  );
};

export default AppExperienceRoute;
